<template>
  <div>
    <!-- <div>latitude: {{ latitude }}</div> -->
    <!-- <div>longitude: {{ longitude }}</div> -->
    <!-- {{ pin }} -->
    <div v-if="latitude == 0 && longitude == 0">
      <h4 class="danger">Essa ocorrência não possui localização</h4>
    </div>
    <!-- <base-path-map
        :latitude="pin.location.latitude"
        :longitude="pin.location.longitude"
      ></base-path-map> -->
    <base-map :apiKey="apiKey" :pin="pin"> </base-map>
  </div>
</template>

<script>
export default {
  name: "WorkflowMap",
  props: {
    latitude: {
      type: Number,
      default: 0.0,
      description: 'Latitude do ponto'
    },
    longitude: {
      type: Number,
      default: 0.0,
      description: 'Longitude do ponto'
    },
  },
  components: {
    BaseMap: () => import("@/components_rms/base/BaseMap.vue"),
  },
  data() {
    return {
      apiKey:
        "As-Vkf2McY-jBXfx3q_vrpwdrFmtyixvHjGFuv90Ak2WD338py0sIQ7wCf5z2D80", //chave da api
    };
  },
  created() {
    if (this.latitude != 0) this.pin.location.latitude = this.latitude;
    if (this.longitude != 0) this.pin.location.longitude = this.longitude;
  },
  computed: {
    pin() {
      return {
        key: "pin1",
        location: {
          latitude: this.latitude,
          longitude: this.longitude,
        },
        visible: true,
      }
    },
  },
  methods: {
  },
};
</script>
<style scoped>
.danger {
  color: #fd5d93 !important;
}
</style>
